import React from "react";
import { IconButton } from "rsuite";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

const ExportButton = ({ result }) => {
  const exportToCSV = () => {
    if (!result) {
      console.error("No data available to export");
      return;
    }
    const jsonData = result;
    const headers = Object.keys(jsonData[0]);
    const csvRows = [];

    csvRows.push(headers.join(","));

    jsonData.forEach((row) => {
      const values = headers.map((header) => {
        const escaped = ("" + row[header]).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const date = new Date();
    const timestamp =
      (date.getMonth() + 1).toString().padStart(2, "0") +
      date.getDate().toString().padStart(2, "0") +
      date.getFullYear().toString() +
      "_" +
      date.getHours().toString().padStart(2, "0") +
      date.getMinutes().toString().padStart(2, "0") +
      date.getSeconds().toString().padStart(2, "0");
    link.download = `maple-query-results_${timestamp}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };
  return (
    <IconButton
      size="sm"
      appearance="primary"
      color="blue"
      icon={<FileDownloadIcon />}
      onClick={exportToCSV}
    >
      Export
    </IconButton>
  );
};

export default ExportButton;
